var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"im-dialog"},[_c('div',{staticClass:"im-dialog__col-left",on:{"mouseup":_vm.mouseup}},[_c('Messages')],1),_vm._v(" "),_c('div',{staticClass:"im-dialog__col-right"},[_c('Info')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }